import { z } from 'zod';

export const ZRegisterUserSchema = z.object({
  agreedToMarketing: z.boolean().optional(),
  appleUserId: z.string().nullable().optional(),
  dateOfBirth: z.string().nullable().optional(),
  emailAddress: z.string().email(),
  firstName: z.string(),
  facebookUserId: z.string().nullable().optional(),
  googleUserId: z.string().nullable().optional(),
  inviterId: z.string().nullable().optional(),
  lastName: z.string(),
  password: z.string().nullable().optional(), // Assuming minimum 6 characters for password
  phoneNumber: z.string().nullable().optional(),
  utmParameters: z.record(z.string()).nullable().optional(),
  abTestVariants: z.record(z.string(), z.string()).optional().nullable(),
});

export const ZLoginUserSchema = z.object({
  email: z.string().email(),
  password: z.string().min(6), // Assuming minimum 6 characters for password
});

export type TRegisterSchema = z.infer<typeof ZRegisterUserSchema>;

export type TLoginSchema = z.infer<typeof ZLoginUserSchema>;

export const ZErrorResponseSchema = z.object({
  message: z.string(),
});
export type TErrorResponse = z.infer<typeof ZErrorResponseSchema>;

export const ZRegisterResponseSchema = z.object({
  player: z.object({
    id: z.string(),
    emailAddress: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    phoneNumber: z.string().nullable(),
    referralId: z.string(),
    status: z.string(),
    role: z.string(),
  }),
  token: z.string(),
});

export type TRegisterResponseSchema = z.infer<typeof ZRegisterResponseSchema>;

export const ZProfileResponseSchema = z.object({
  id: z.string(),
  emailAddress: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  phoneNumber: z.string().nullable(),
  referralId: z.string(),
  status: z.string(),
  role: z.string(),
  abtestVariants: z.record(z.string(), z.string()).optional().nullable(),
});

export type TProfileResponseSchema = z.infer<typeof ZProfileResponseSchema>;

const ZUserSchema = z.object({
  id: z.string(),
  emailAddress: z.string(),
  firstName: z.string(),
  role: z.string(),
});

export type TUserSchema = z.infer<typeof ZUserSchema>;

export type TUserOptionalSchema = TUserSchema | undefined;

export const ZRequestPasswordReset = z.object({
  emailAddress: z.string(),
});

export const ZUsePasswordReset = z.object({
  resetToken: z.string(),
  newPassword: z.string(),
});
